<template>
  <main-sidebar :name="name" :title="$t('assign_client')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="6"
          vs-lg="6"
        >
          <vs-row vs-w="12" class="mr-1">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="12"
            >
              <label>{{ $t('folio') }}</label>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="12"
            >
              <vs-input :value="expense.Folio" class="w-full" disabled />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="6"
          vs-lg="6"
        >
          <vs-row vs-w="12" class="ml-1">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="12"
            >
              <label>{{ $t('date') }}</label>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="12"
            >
              <vs-input
                :value="formatDate(expense.ReceivedDate)"
                class="w-full"
                disabled
              />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('total') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input
            :value="`$ ${formatNumber(expense.Total, 2)} ${expense.CurrencyId}`"
            class="w-full"
            disabled
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('vendor') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input v-model="expense.VendorName" class="w-full" disabled />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('company') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input :value="expense.CompanyName" class="w-full" disabled />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="client"
            :options="filterClients"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>
      <vs-row
        vs-w="12"
        class="mb-2 mt-4"
        v-if="client == '19' || client == '62' || client == '122'">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('departament') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="departament"
            :options="departaments"
            class="w-full"
            :reduce="(departament) => departament.id"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('category') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="category"
            :options="categoryList"
            class="w-full"
            :reduce="(category) => category.CategoryId"
            label="CategoryName"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('account') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input v-model="account" class="w-full" />
        </vs-col>
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="assign" :disabled="client === null || category === null">
        {{ $t('assign') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import mixins from '@/mixins'
import loading from '@/mixins/Loading'
import MainSidebar from '@/views/components/MainSidebar'
import vSelect from 'vue-select'
import client from '@/http/requests/client'
import expense from '@/http/requests/expense'

export default {
  components: {
    MainSidebar,
    vSelect,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    filterClients() {
      return this.clientList.filter(
        (client) => client.CompanyId == this.expense.CompanyId
      )
      //const list =
      // if (list.length > 0){
      //     this.client = list[0].ClientId
      // }
      // return list
    },
    isLoading() {
      return (
        this.loading.clients || this.loading.submit || this.loading.departaments
      )
    },
  },
  data() {
    return {
      account: null,
      category: null,
      client: null,
      clientList: [],
      categoryList: [],
      departaments: [],
      departament: null,
      name: 'assign-client',
      loading: {
        categories: false,
        clients: false,
        submit: false,
        departaments: false,
      },
    }
  },
  methods: {
    init() {
      this.account = this.expense.AccountNumber
      this.departament = null
      this.category = null
      this.client = null
      this.getClients()
      this.getCategories()
      this.getDepartaments()
    },
    getClients() {
      this.loading.clients = true
      let params = {
        all: 'all actives',
      }
      client
        .list(params)
        .then((res) => {
          this.clientList = res.data.clients
          this.client = this.expense.ClientId
          this.loading.clients = false
        })
        .catch((err) => {
          this.loading.clients = false
        })
    },
    getCategories() {
      this.loading.categories = true
      expense
        .getCategories()
        .then((res) => {
          this.categoryList = res.data.categories
          this.category = this.expense.CategoryId
          this.loading.categories = false
        })
        .catch((err) => {
          this.loading.categories = false
        })
    },
    clear() {
      this.close()
    },
    assign() {
      this.loading.submit = true
      const data = {
        client: this.client,
        expense: this.expense.ExpenseId,
        account: this.account,
        category: this.category,
        departament: this.departament,
      }
      

      this.$store
        .dispatch('expense/assignClient', data)
        .then((res) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            text: `Updated`,
          })
          this.close()
        })
        .catch((err) => {
          this.loading.submit = false
          this.showValidationErrors(err)
        })
    },

    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    getDepartaments() {
      this.loading.departaments = true
      expense
        .getDepartaments()
        .then((response) => {
          this.departaments = response.data.map((el) => ({
            id: String(el.id),
            name: el.name,
          }))
          this.departament = this.expense.departament_budget_id
          this.loading.departaments = false
        })
        .catch((error) => {
          this.loading.departaments = false
          this.showValidationErrors(error)
        })
    },
    validate() {},
  },
  mixins: [mixins, loading],
  props: {
    expense: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>